import styled from 'styled-components'

const BannerImage = styled.img`
    display: block;
    height: 220px;
    width: 100%
`

export default BannerImage